<template>
  <block
    component-name="block-text-btn-list"
    body-class="grid grid-cols-12 gap-x-ui gap-y-3xl"
  >
    <txt-chapter
      size="big"
      :overline="$attrs.data.body.overline || undefined"
      :title="$attrs.data.body.title"
      :text="$attrs.data.body.text || undefined"
      :button="$attrs.data.body.button || undefined"
      class="col-span-full laptop:col-start-1 laptop:col-end-7 w-full"
    />

    <btn-list
      v-if="finalItems?.length"
      :asset="$attrs.data.body.list.asset || undefined"
      :title="$attrs.data.body.list.title || undefined"
      :items="finalItems"
      class="col-span-full laptop:col-start-8 laptop:col-end-12 w-full"
    />
  </block>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
const userStore = useUserStore();
const attrs = useAttrs();
const nuxtApp = useNuxtApp();
const finalItems = computed(() => {
  if (
    !attrs.config.useBespokeAndProjectConsultancy ||
    attrs.config.useBespokeAndProjectConsultancy &&
    userStore.user?.type === "private"
  ) {
    return attrs.data.body.list.items;
  } else {
    return [
      {
        title: nuxtApp.$t.labels.book_consultancy,
        action: {
          to: "/bespoke-and-project-consultancy",
        },
        icon: "book-consultancy",
      },
      ...attrs.data.body.list.items,
    ];
  }
});
</script>
